import { Warning } from './warning';

export type PriceWarningList = {
    priceId: number;
    warnings: Warning[];
};

